import ThongBaoSaiSotTinhChat from "./ThongBaoSaiSotTinhChat";

export default ThongBaoSaiSotTinhChat